import { Form, Formik } from 'formik'
import { useMemo } from 'react'
import styled from 'styled-components'
import { useUserProfile } from '../../hooks/useUserProfile'
import { Button } from '../Button'
import { Input } from '../Input'
import { Select } from '../Select'

const GeneralTab = () => {
    const { user, updateUser } = useUserProfile()

    const initialUserData = useMemo(
        () => ({
            firstName: user?.user_metadata?.first_name,
            secondName: user?.user_metadata?.second_name,
            currency: user?.user_metadata?.currency,
            email: user?.email,
        }),
        [user]
    )

    const handleSubmit = (userData: typeof initialUserData) => {
        updateUser({ ...userData })
    }

    return (
        <Formik
            initialValues={initialUserData}
            onSubmit={handleSubmit}
            enableReinitialize
        >
            <Form style={{ width: '100%' }}>
                <TabContainer>
                    <Container>
                        <Input name="firstName" placeholder="Имя" />
                    </Container>
                    <Container>
                        <Input name="secondName" placeholder="Фамилия" />
                    </Container>
                    <Container>
                        <Input name="email" placeholder="email" />
                    </Container>
                    <Container>
                        <Select
                            name="currency"
                            placeholder="Валюта"
                            options={['RUB', 'USD', 'BYN', 'EUR']}
                        />
                    </Container>
                    <SubmitContainer>
                        <Button type="submit">Изменить</Button>
                    </SubmitContainer>
                </TabContainer>
            </Form>
        </Formik>
    )
}

const TabContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
`

const Container = styled.div`
    width: 100%;
    padding: 8px;
`
const SubmitContainer = styled(Container)``

export { GeneralTab }
